/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable no-unused-expressions */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable no-useless-return */
/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable no-shadow */
/* eslint-disable @typescript-eslint/no-empty-function */
/* eslint-disable no-else-return */
/* eslint-disable array-callback-return */
/* eslint-disable consistent-return */
/* eslint-disable react/jsx-key */
/* eslint-disable react/no-array-index-key */
/* eslint-disable no-param-reassign */
/* eslint-disable react/jsx-boolean-value */
/* eslint-disable object-shorthand */
/* eslint-disable camelcase */
/* eslint-disable no-nested-ternary */
/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState, useCallback } from "react";

import { Box, List, ListSubheader, Stack, useMediaQuery } from "@mui/material";

import { Form } from "@unform/web";
import { MdSearch } from "react-icons/md";
import { FormHandles } from "@unform/core";

import { ItemText } from "../../../components/itemText";
import theme from "../../../theme";
import HeaderComp from "../../../components/header";
import { Container, TabelaDiv } from "./styles";
import Input from "../../../components/Input";
import ButtonStyled from "../../../components/Button";
import TicketingService from "../../../services/ticketing";
import { CardTable } from "./Components/RechargeTableComponent";
import { CardsResponse } from "../../../interfaces/cards";
import { useToast } from "../../../hooks/toast";

interface DadosFiltros {
  value: string;
  label: string;
}

const CardVerify: React.FC = () => {
  const services = { ticketingService: new TicketingService() };

  const pageSize = useMediaQuery("(max-width:1600px)");

  React.useState<DadosFiltros | null>(null);
  const [expandedRow, setExpandedRow] = useState<string | null>(null);

  const { addToast } = useToast();

  const [dadosBusca, setDadosBusca] = React.useState<CardsResponse>(
    {} as CardsResponse
  );
  const [loading, setLoading] = useState<boolean>(true);

  const [localClean, setLocalClean] = useState<boolean>(true);

  const formRef = React.useRef<FormHandles>(null);

  const handleSearch = useCallback(
    async (data: any) => {
      try {
        const searchFor = data.search;
        console.log(data);
        setLoading(true);

        const response = await services.ticketingService.getCardVerify(
          searchFor
        );

        setDadosBusca(response.data);

        setLoading(false);
      } catch (error: any) {
        setDadosBusca({} as CardsResponse);

        addToast({
          type: "error",
          title: "Erro",
          description: `${error?.response?.data.message}`,
        });
      }
    },
    [dadosBusca, loading]
  );

  useEffect(() => {
    const handleBeforeUnload = (event: BeforeUnloadEvent) => {
      localStorage.removeItem("RecargaStatus");

      // Exemplo: salvar dados no localStorage antes de sair
      localStorage.setItem("lastVisit", new Date().toISOString());
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    // Remover o listener quando o componente é desmontado
    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, []);

  useEffect(() => {}, [dadosBusca]);

  return (
    <>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
        }}
      >
        <HeaderComp filtroNaparece={true} />
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            margin: 0,
          }}
        >
          <Box sx={{ display: "flex", flexGrow: 1, width: "100%" }}>
            <Box sx={{ flexGrow: 1, textAlign: "center", width: "100%" }}>
              <Container>
                <List
                  sx={{
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    margin: 2,
                    justifyContent: "center",
                  }}
                >
                  <Box
                    sx={{
                      backgroundColor: "RGB(248, 248, 248)",
                      borderRadius: 4,
                      boxShadow: "2px 2px 4px rgba(0, 0, 0, 0.3)",
                      overflowX: "auto",
                      display: "grid",
                      padding: "2%",
                      minWidth: "80%",
                    }}
                  >
                    <Stack
                      sx={{
                        zIndex: 0,
                      }}
                    >
                      <ListSubheader
                        sx={{
                          width: "100%",
                          textAlign: "center",
                          fontWeight: "bold",
                          marginTop: "10px",
                          backgroundColor: "RGB(248, 248, 248)",
                        }}
                      >
                        <Box>
                          <ItemText
                            primary="VERIFICAR CARTÃO"
                            hideSecondary
                            primarySx={{
                              color: theme.palette.secondary.main,
                              fontSize: pageSize ? "30px" : "20px",
                              fontWeight: "bold",
                            }}
                          />
                        </Box>
                      </ListSubheader>
                    </Stack>
                    <Stack
                      className="Filtros"
                      sx={{
                        display: "flex",
                        justifyContent: "space-around",
                        textAlign: "center",
                        alignItems: "center",
                        marginLeft: "10px",
                        marginRight: "10px",
                      }}
                    >
                      <Stack
                        sx={{
                          display: "contents",
                          justifyContent: "center",
                          textAlign: "center",
                          alignItems: "center",
                          marginRight: "20px",
                          borderRadius: "10px",
                          padding: "5px",
                        }}
                      >
                        <Form
                          ref={formRef}
                          onSubmit={handleSearch}
                          style={{
                            display: "flex",
                            marginBottom: "10px",
                          }}
                        >
                          <Input
                            id="search"
                            name="search"
                            type="text"
                            placeholder="Digite o cartão selecionado"
                            style={{
                              minWidth: pageSize ? "100px" : "300px",
                              borderColor: theme.palette.primary.main,
                            }}
                          />

                          <ButtonStyled
                            color="orange"
                            padding="1"
                            type="submit"
                            className="searchButton"
                            style={{
                              marginLeft: "5px",
                              marginTop: pageSize ? "0px" : "0px",
                            }}
                          >
                            <MdSearch size={20} />
                          </ButtonStyled>
                        </Form>
                        {dadosBusca?.card_number && (
                          <Stack
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <h4
                              style={{
                                fontWeight: "bold",
                                color: "var(--orange)",
                              }}
                            >
                              Cartão Selecionado: &nbsp;
                            </h4>
                            <p
                              style={{
                                fontWeight: "bold",
                                color: "var(--purple)",
                              }}
                            >
                              {dadosBusca?.card_number}
                            </p>
                          </Stack>
                        )}

                        {!dadosBusca?.card_number && (
                          <Stack
                            sx={{
                              display: "flex",
                              flexDirection: "row",
                            }}
                          >
                            <h4
                              style={{
                                fontWeight: "bold",
                                color: "var(--orange)",
                              }}
                            >
                              Nenhum Cartão Selecionado
                            </h4>
                          </Stack>
                        )}
                      </Stack>
                    </Stack>
                    {!loading && dadosBusca?.card_number && (
                      <TabelaDiv className="Tabela">
                        <CardTable
                          data={dadosBusca?.users.map((user: any) => ({
                            ...user,
                            isExpanded: expandedRow === user.card_id,
                          }))}
                          clearLocalStorage={localClean}
                          columns={[
                            {
                              name: <div>Id do Cartão</div>,
                              selector: "card_id",
                              cell: ({ card_id }: any) => (
                                <div className="specifitcell">{card_id}</div>
                              ),
                            },
                            {
                              name: <div>Apelido</div>,
                              selector: "card_nickname",
                              cell: ({ card_nickname }: any) => (
                                <div className="specifitcell">
                                  {card_nickname}
                                </div>
                              ),
                            },
                            {
                              name: <div>Email</div>,
                              selector: "user_email",
                              cell: ({ user_email }: any) => (
                                <div className="specifitcellS">
                                  {user_email}
                                </div>
                              ),
                            },
                            {
                              name: <div>CPF</div>,
                              selector: "user_cpf",
                              cell: ({ user_cpf }: any) => (
                                <div className="specifitcellS">{user_cpf}</div>
                              ),
                            },
                            {
                              name: <div>Data de Cadastro</div>,
                              selector: "created_at",
                              cell: ({ created_at }: any) => (
                                <div className="specifitcell">{created_at}</div>
                              ),
                            },
                            {
                              name: <div>Data de Exclusão</div>,
                              selector: "deleted_at",
                              cell: ({ deleted_at }: any) => (
                                <div className="specifitcell">{deleted_at}</div>
                              ),
                            },
                            {
                              name: <div>Data de Atualização</div>,
                              selector: "updated_at",
                              cell: ({ updated_at }: any) => (
                                <div className="specifitcell">{updated_at}</div>
                              ),
                            },
                          ]}
                        />
                      </TabelaDiv>
                    )}
                    {!dadosBusca?.card_number && (
                      <div
                        style={{
                          backgroundColor: "rgba(225, 225, 225, 0.78)",
                          borderRadius: "10px",
                          padding: "2%",
                          marginTop: "1%",
                          minHeight: "100px",
                          display: "flex",
                          alignItems: "center",
                          textAlign: "center",
                          justifyContent: "center",
                        }}
                      >
                        <h3 style={{ color: "var(--purple)" }}>
                          Nenhum dado encontrado, por favor realize uma busca
                        </h3>
                      </div>
                    )}
                  </Box>
                </List>
              </Container>
            </Box>
          </Box>
        </Box>
      </Box>
    </>
  );
};

export default CardVerify;
